import React from 'react'
import { useEffect, useState } from 'react'
import { News } from "../../components/sections/News";
import { Search } from "../../components/layout/Search";
import { Services } from "../../components/sections/Services";
import { Videos } from "../../components/sections/Videos";
import { Conectai } from "../../components/sections/Conectai";
import { Banner } from "../../components/sections/Banner";
import { Notice } from "../../components/ui/Notice";
import { Popup } from "../../components/ui/Popup";
import { useApp } from "../../context/App";
import { ServicesAccordion } from "../../components/sections/ServicesAccordion";
import { AcessoRapido } from "../../components/sections/AcessoRapido";
import { api, urls } from "../../services/api"
import { IModal } from '../../types/modal';
import { SearchMobile } from "../../components/layout/SearchMobile";

export function HomeScreen() {

	const { mobile, tenant } = useApp()

	const [ativarPopup, setPopup] = useState(false)

	useEffect(() => {
		(async () => {
			try {

				const responseModal = await api.get<IModal[]>(urls.Modal)

				// // console.log('responseModal.data:', responseModal.data)
				// // console.log('responseModal.data.length:', responseModal.data.length)

				if (responseModal.data.length !== 0) { setPopup(true) }

			} catch (error) {
				// console.log('responseModal.data.error:', error)
			}
		})()
	}, [])

	return (
		<div className="flex flex-col w-full bg-white dark:bg-surface-dark transition-colors min-h-screen">
			{ativarPopup && <Popup />}

			{mobile ? (
				<SearchMobile />
			) : (
				<Search />
			)}

			<Notice />
			<News />

			{tenant.features.showAcessoRapido && <AcessoRapido />}

			{tenant.features.showServices && (
				mobile ? (
					<ServicesAccordion />
				) : (
					<Services />
				)
			)}



			<Banner mobile={mobile} />
			<Videos mobile={mobile} />
			<Conectai />
		</div>
	)
}